import { logger } from "../..";
var JabberJidVoData = /** @class */ (function () {
    function JabberJidVoData(bare, isJID) {
        try {
            var result = bare.split("@");
            this.bare = bare;
            this.local = result[0];
            this.domain = result[1];
            this.isJID = isJID;
        }
        catch (e) {
            logger.info(e);
        }
    }
    return JabberJidVoData;
}());
export { JabberJidVoData };
//# sourceMappingURL=jabber-jid-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/jabber/jabber-jid-vo-data.js
// module id = 942
// module chunks = 14